import { Chip, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GitHubIcon from "@material-ui/icons/GitHub";
import {
  CheckStandard,
  EnforcementLevel,
} from "@internal/plugin-front-door-common";

const useStyles = makeStyles((theme) => ({
  enforced: {
    fontWeight: 700,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

/** What the enforcement badge shows for a check. */
export interface EnforcementInfo {
  enforcement: EnforcementLevel;
  /** The level's label. */
  enforcementLabel: string;
  enforcedByGitHub: boolean;
  standard?: CheckStandard;
  /** "Proposed" and so on while the control is not active. */
  statusLabel?: string;
}

/**
 * The check's enforcement badge, filled only when enforced, with its standard
 * as a tooltip, "enforced by GitHub" when GitHub blocks the failure, and the
 * control's status while it is not active.
 */
export function EnforcementChips({ check }: { check: EnforcementInfo }) {
  const classes = useStyles();
  const enforced = check.enforcement === "enforced";
  const chip = (
    <Chip
      size="small"
      label={check.enforcementLabel}
      variant={enforced ? "default" : "outlined"}
      className={enforced ? classes.enforced : undefined}
    />
  );
  const { standard } = check;
  const tooltip =
    standard &&
    (standard.registry
      ? `Standard: ${standard.registry.title} (${standard.registry.status})`
      : `Standard: ${standard.id}`);
  return (
    <>
      {tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip}
      {check.enforcedByGitHub && (
        <Chip
          size="small"
          variant="outlined"
          icon={<GitHubIcon aria-hidden />}
          label="enforced by GitHub"
        />
      )}
      {check.statusLabel && (
        <Tooltip title="The control is not active yet, so it is not enforced">
          <Chip size="small" variant="outlined" label={check.statusLabel} />
        </Tooltip>
      )}
    </>
  );
}
